import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'traceability',
  templateUrl: './traceability.component.html',
  styleUrls: ['./traceability.component.scss']
})
export class TraceabilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
